import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../../contexts/EncoreContext";
import { Experimental__Icon, findClosestGlyphAvailable } from "../../";
export function Experimental__IconChevronUp(props) {
  var iconList = [{
    "size": 16,
    "svgContent": "<path d=\"M14.62 11.52L8 3.77l-6.62 7.75-.76-.649L8 2.23l7.38 8.641z\"/>"
  }, {
    "size": 24,
    "svgContent": "<path d=\"M20.161 17.324L12 7.769l-8.161 9.555-.76-.649L12 6.23l8.921 10.445z\"/>"
  }, {
    "size": 32,
    "svgContent": "<path d=\"M28.62 23.545L16 8.769 3.38 23.545l-.76-.649L16 7.23l13.38 15.666z\"/>"
  }, {
    "size": 48,
    "svgContent": "<path d=\"M40.321 33.649L24 14.54 7.679 33.649l-1.522-1.298L24 11.46l17.843 20.891z\"/>"
  }, {
    "size": 64,
    "svgContent": "<path d=\"M55.24 46.999L32 19.789 8.76 46.999 7.24 45.7 32 16.709 56.76 45.7z\"/>"
  }];
  var iconListRedraw = [{
    "size": 16,
    "svgContent": "<path d=\"M.47 11.03a.75.75 0 001.06 0L8 4.56l6.47 6.47a.75.75 0 101.06-1.06L8 2.44.47 9.97a.75.75 0 000 1.06z\"/>"
  }, {
    "size": 24,
    "svgContent": "<path d=\"M2.793 15.957a1 1 0 001.414 0L12 8.164l7.793 7.793a1 1 0 101.414-1.414L12 5.336l-9.207 9.207a1 1 0 000 1.414z\"/>"
  }];
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);
  var iconListFallback = iconList.length === 0 ? iconListRedraw : iconList;
  var closestSize = findClosestGlyphAvailable(status === encoreContextStatus.next ? iconListRedraw : iconListFallback, props.iconSize || 24);
  return /*#__PURE__*/React.createElement(Experimental__Icon, Object.assign({}, props, {
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: closestSize.svgContent
    }
  }));
}
export default Experimental__IconChevronUp;